import React, { Component } from "react";
import Draggable from "react-draggable";
import { connect } from "react-redux";
import { ComboBox } from "office-ui-fabric-react/lib-commonjs/ComboBox";
import "./index.css";
import {
  floatingToolInsertaTeeClose,
  floatingToolInsertaTeeOpen,
  floatingToolTeeMoved
} from "../../actions/floating-tool-inserta-tee-actions";
import {
  setChamberAccesory
} from "../../actions/floating-tool-actions";
import { ManifoldUtils } from "../../lib/manifolds/utils";
import { convertUnits } from "../../lib/misc/misc_utils";

const defaultState = {
  position: "center",
  placement: "top",
  showConfirmation: false,
  insertaTeeSizes: [4],
  selectedSize: 4,
  currentAccessory: null
};

class FloatingToolInsertaTee extends Component{
  state = defaultState;

  componentDidUpdate( prevProps ) {
    let names = ["selected"];
    if (this.anyPropHasChanged(prevProps, names)
    ) {
      this.setState(defaultState);
    }
    if (this.props.selected && this.props.selected !== prevProps.selected) {
      let mData = ManifoldUtils.getMainDatasetByChamberId(this.props.chamberType.id);
      if (mData.insTeeSizes.length > 0) {
        this.setState({
          insertaTeeSizes: [...mData.insTeeSizes]
        });
      }
      const chamberContainsTee = ( this.props.chamberRows[this.props.currentAccessory.row]._chambers[this.props.currentAccessory.col]._accessory
        && this.props.chamberRows[this.props.currentAccessory.row]._chambers[this.props.currentAccessory.col]._accessory.id === "Inserta-tee" );

      if (chamberContainsTee) {
        const cuAccessory = this.props.chamberRows[this.props.currentAccessory.row]._chambers[this.props.currentAccessory.col]._accessory;

        if (cuAccessory.size) {
          this.setState({
            selectedSize: cuAccessory.size
          });
        } else {
          this.setState({
            selectedSize: 4
          });
        }

        this.setState({
          currentAccessory: cuAccessory
        });
      } else {
        setTimeout(() =>
          this.props.setChamberAccesory(this.props.currentAccessory.row, this.props.currentAccessory.col, this.props.currentAccessory.accessory)
        );
        this.setState({
          selectedSize: this.props.currentAccessory.accessory.size
        });
        this.setState({
          currentAccessory: this.props.currentAccessory // This accessory comes from the template on creation
        });
      }
    }
  }

  /**
   * This method receives the previous properties object and an Array of
   * the properties to be determined if have changed and returns true if any
   * have changed, or false if all are the same.
   * @param {Object} prevProps The previous properties of the component.
   * @param {Array<string>} propNames The Properties names array.
   */
  anyPropHasChanged( prevProps, propNames ) {
    let changed = false;
    for (let name of propNames) {
      changed = this.props[name] !== prevProps[name] || changed;
    }
    return changed;
  }

  handleCloseClick() {
    this.props.floatingToolInsertaTeeClose();
  }

  render() {
    const {
      x,
      y,
      selected,
      projectType
    } = this.props;

    const {
      insertaTeeSizes,
      selectedSize
    } = this.state;

    if (selected === true && projectType === "CHAMBER") {
      const handleDragStop = ( event, node ) => {
        if (x !== node.x || y !== node.y) {
          this.props.floatingToolTeeMoved(node.x, node.y);
        }
      };

      const renderTeeSelector = () => {
        const teeList = insertaTeeSizes.map(a => {
          const unitPostFix = ( this.props.unit === "imperial" ) ? " \"" : " mm";
          return {
            text: `${a[this.props.unit]}${unitPostFix}`,
            key: a.value
          };
        });

        teeList.push({
          text: this.props.content[this.props.lang].none,
          key: 0
        });

        return <React.Fragment>
          <div className="teeFloatingOptions">

            <ComboBox
              selectedKey={selectedSize}
              label={this.props.content[this.props.lang].Diameter}
              id="TeeValues"
              ariaLabel={this.props.content[this.props.lang].Diameter}
              options={teeList}
              onChanged={value => {
                if (value.key === 0) {
                  this.props.setChamberAccesory(
                    this.props.currentAccessory.row,
                    this.props.currentAccessory.col,
                    null
                  );
                } else {
                  console.log("change value", this.props.currentAccessory.row,
                    this.props.currentAccessory.col);
                  const payloadAccessory = {
                    ...this.props.currentAccessory.accessory,
                    size: value.key
                  };
                  this.props.setChamberAccesory(
                    this.props.currentAccessory.row,
                    this.props.currentAccessory.col,
                    payloadAccessory
                  );
                }
                this.setState({
                  selectedSize: value.key
                });
                // this.props.floatingToolInsertaTeeClose();
              }}
            />
          </div>
        </React.Fragment>;
      };

      const renderToolContent = () => {
        let body = `
                ${this.props.content[this.props.lang].InsertaTeeOptions}
                `;
        return (
          <div className="FloatingToolInsertaTee">
            <div className="handle">
                              <span className="closeButton"
                                    onClick={this.handleCloseClick.bind(this)}>
                                X
                              </span>
            </div>
            {body}
            {renderTeeSelector()}
          </div>
        );
      };

      return (
        <div>
          <Draggable
            onStop={handleDragStop.bind(this)}
            bounds="#layout"
            handle=".handle"
            position={{ x: this.props.x, y: this.props.y }}
          >
            {renderToolContent()}
          </Draggable>
        </div>
      );
    } else {
      return <span style={{ display: "none" }} />;
    }
  }
}

const mapStateToProps = state => {
  const currentAccessory = {
    row: state.floatingToolInsertaTee.row,
    col: state.floatingToolInsertaTee.col,
    accessory: state.floatingToolInsertaTee.accessory
  };

  return {
    x: state.floatingToolInsertaTee.x,
    y: state.floatingToolInsertaTee.y,
    lang: state.localization.lang,
    content: state.localization.content,
    projectType: state.globals.projectType,
    chamberType: state.globals.chamberType,
    chamberRows: state.chamberbed.chamberRows,
    chamberbed: state.chamberbed,
    accessories: state.apptoolbar.accessories,
    currentAccessory: currentAccessory,
    selected: state.floatingToolInsertaTee.openDialog,
    unit: state.localization.unit,
  };
};

const mapDispatchToProps = {
  floatingToolTeeMoved,
  floatingToolInsertaTeeOpen,
  floatingToolInsertaTeeClose,
  setChamberAccesory
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FloatingToolInsertaTee);



// WEBPACK FOOTER //
// ./src/components/FloatingToolInseraTee/index.js